export enum DeliveryNoteTemplateType {
  Download = 1,
  Email = 2,
}
